import { render, staticRenderFns } from "./PasswordResetComponent.vue?vue&type=template&id=0e34a402&scoped=true&"
import script from "./PasswordResetComponent.vue?vue&type=script&lang=js&"
export * from "./PasswordResetComponent.vue?vue&type=script&lang=js&"
import style0 from "./PasswordResetComponent.vue?vue&type=style&index=0&id=0e34a402&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e34a402",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/neta-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0e34a402')) {
      api.createRecord('0e34a402', component.options)
    } else {
      api.reload('0e34a402', component.options)
    }
    module.hot.accept("./PasswordResetComponent.vue?vue&type=template&id=0e34a402&scoped=true&", function () {
      api.rerender('0e34a402', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/login/PasswordResetComponent.vue"
export default component.exports